export default __webpack_public_path__ + "static/media/plus.043fe9f3.svg";